import axios from "axios";

const API_URL = "/api/config";

let _branding = null;

export async function fetchBranding() {
  if (_branding) {
    return _branding;
  }
  const response = await axios.get(`${API_URL}/branding`);
  _branding = response.data;
  return _branding;
}

export function getBranding() {
  return _branding;
}

const BrandingService = {
  fetch: fetchBranding,
  get: getBranding,
  clear: () => {
    _branding = null;
  },
};

export default BrandingService;
